import React from 'react';
import ImagePlaceholder from '../../../assets/img/img_placeholder.jpg';

export default ({ data }) => (
    <div className="row">
        <div className="col-md-6 mb-2">
            <div className="form-group">
                <label>Name</label>
                <p>{data.name}</p>
            </div>
        </div>
        <div className="col-md-6 mb-2">
            <div className="form-group">
                <label>Phone</label>
                <p>{'+'+data.countryCode+'-'+data.phoneNumber}</p>
            </div>
        </div>
        <div className="col-md-6 mb-2">
            <div className="form-group">
                <label>Date of Birth</label>
                <p>{data.dateOfBirth}</p>
            </div>
        </div>
        <div className="col-md-6 mb-2">
            <div className="form-group">
                <label>Profile Image</label>
                <p>
                    <img src={data.profilePicture || ImagePlaceholder} width="200px"/>
                </p>
            </div>
        </div>
    </div>
);